import React, { useEffect, useState, useMemo } from 'react';
import { TextField, Button, Box, DialogActions, DialogContent, DialogTitle
  , useMediaQuery, Dialog, Snackbar, Paper } from '@mui/material';
import { themeQuartz } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import { useTheme } from '@mui/material/styles';
import { useSaveImportStatusMutation } from '../../services/product';
import XLSX from 'xlsx-js-style';//import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import ConfirmDialog from '../tools/comfirmDialog';
import LoadingPage from '../loadingPage';
import moment from 'moment';

export default function ImportExcel({open, setOpen, priority}) {
  const theme1 = useTheme();
  const fullScreen = useMediaQuery(theme1.breakpoints.down('md'));
	const [loading, setLoading] = useState(false);
  const [saveImportStatus] = useSaveImportStatusMutation();
  const [alert, setAlert] = useState(false);
  const [excelData, setExcelData] = useState([]);
  const [confirm, setConfirm] = useState(false);
  const [columns, setColumns] = useState([]);
  const [gridHeight, setGridHeight] = useState(300);

  useEffect(() => {
    setGridHeight(window.innerHeight - 210);
  }, []);

  const handleClose = () => {
    setOpen(false);
    setExcelData([]);
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setLoading(true);
      setTimeout(() => {
        const reader = new FileReader();
        reader.onload = (e) => {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: 'array' });
          const sheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[sheetName];
          const json = XLSX.utils.sheet_to_json(worksheet, {
            //range: 0,
            raw: false,
            dateNF: "yyyy-mm-dd"
          });
          const filtered = json.map(row => {
            if (!row || typeof row !== 'object') return null;
            const keys = Object.keys(row);
            if(open == 'btq_priority')
              return {
                BtqCode: String(row[keys[0]] || '').trim(),
                BtqName: String(row[keys[1]] || '').trim(),
                Priority: String(row[keys[2]] || '').trim()
              };
            else
              return {
                StoreCode: String(row[keys[0]] || '').trim(),
                Barcode: String(row[keys[1]] || '').trim()
              };
          }).filter(Boolean);
          if(open == 'btq_priority'){
            const distinctRows = filtered.filter((row, index, self) =>
              index === self.findIndex((r) => 
                r.BtqCode === row.BtqCode
              )
            );
            setExcelData(distinctRows);
          }
          else{
            const distinctRows = filtered.filter((row, index, self) =>
              index === self.findIndex((r) => 
                r.StoreCode === row.StoreCode && r.Barcode === row.Barcode
              )
            );
            setExcelData(distinctRows);
          }
          filtered.length > 0 &&
            getColumns(filtered[0]);

        };
        reader.readAsArrayBuffer(file);

        setLoading(false);
      }, 200);
    }
  };

  const getColumns=(item)=>{
    const cols = Object.keys(item).map((key) => {
      return {
        field: key, width: 150
      }
    });
    setColumns(cols);
  }

  const myTheme = themeQuartz.withParams({
    wrapperBorder: false,
    headerRowBorder: false,
    columnBorder: { style: "dashed", color: '#9696C8' },
    headerColumnBorder: { style: 'solid', width: 1, color: '#ccc' },
  });

  const theme = useMemo(() => {
    return myTheme;
  }, []);

  useEffect(() => {
    if(priority && priority.length > 0){
      setExcelData(priority);
      getColumns(priority[0]);
    }
  }, [priority]);

  const onSave = async() =>{
		setLoading(true);
    try {
      setConfirm(false);
      let error = false;
			const formData = new FormData();
      formData.append("table", open);
			formData.append("data", JSON.stringify(excelData));
			const dt = await saveImportStatus(formData).unwrap();
			if(dt[0].ERROR) error = dt[0].ERROR;
      
      if(error)
        setAlert(error);
      else{
        setAlert(`Đã cập nhật ${excelData.length} dòng!`);
				setExcelData([]);
        setOpen(false);
      }
    } catch (err) {
      setAlert("Lỗi kết nối!");
      console.error(err);
    }
		setLoading(false);
  }

  const exportToCSV = () => {
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const ws = XLSX.utils.json_to_sheet(excelData);
    const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], {type: fileType});
    saveAs(data, "BtqPriority.xlsx");
  }

  return (
    <React.Fragment>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title" sx={{textAlign: 'center', fontWeight: 600}}>
          {open}
        </DialogTitle>
                {/* <Divider /> */}
        <DialogContent>
          { (loading) && <LoadingPage /> }
          <input type="file" accept=".xlsx, .xls" onChange={handleFileUpload} />
            <Paper sx={{ height: gridHeight, width: '100%', float: 'left' }}>
              <AgGridReact enableCellTextSelection={true} ensureDomOrder={true}
                rowData={excelData}
                columnDefs={columns}
                pagination={true}
                paginationPageSize={200}
                paginationPageSizeSelector={[200, 500, 1000]}
                theme={theme}
              />
            </Paper>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose}>
            CLOSE
          </Button>
          <Button onClick={()=>setConfirm(`Xác nhận hệ thống sẽ ghi đè dữ liệu`)} autoFocus>
            SAVE
          </Button>
          <Button onClick={()=>exportToCSV()} autoFocus>
            EXPORT
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={alert}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        autoHideDuration={6000}
        onClose={()=>setAlert(false)}
        message={alert}
        // action={action}
      />

      <ConfirmDialog confirm={confirm} setConfirm={setConfirm} onConfirm={onSave}/>
    </React.Fragment>
  );
}